import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Tooltip, Tabs, Tag } from 'antd';
import CustomModal from '../../components/common/CustomModal';
import { FaEdit, FaMobileAlt, FaGlobe, FaSearch, FaEye } from 'react-icons/fa';
import { FiHelpCircle } from 'react-icons/fi';
import Table from '../../components/Table';
import shared from './shared';
import Layout from '../../components/global/layout';
import moment from 'moment';
import methodModel from '../../methods/methods';
import { useSelector } from 'react-redux';

function Html({
  filter,
  edit,
  view,
  pageChange,
  count,
  clear,
  filters,
  setFilter,
  loading,
  data,
  total,
}) {
  const user = useSelector((state) => state.user);
  const [isHelpModalVisible, setIsHelpModalVisible] = useState(false);

  const columns = [
    {
      key: 'heading',
      name: 'Title',
      sort: true,
      render: (row) => <span className="capitalize">{row?.heading?.replace(/_/g, ' ')}</span>,
    },
    {
      key: 'platform',
      name: 'Platform',
      render: (row) => {
        const isApp = row?.platform?.toLowerCase() === 'app';
        return (
          <div className="flex items-center">
            {isApp ? (
              <div className="flex items-center gap-1.5 px-3 py-1 rounded-lg bg-[#CC990012] border border-[#CC990020] text-[#CC9900] text-[11px] font-bold uppercase tracking-wide shadow-sm">
                <FaMobileAlt size={11} />
                <span>App</span>
              </div>
            ) : (
              <div className="flex items-center gap-1.5 px-3 py-1 rounded-lg bg-[#CC990012] border border-[#CC990020] text-[#CC9900] text-[11px] font-bold uppercase tracking-wide shadow-sm">
                <FaGlobe size={11} />
                <span>Web</span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      key: 'updatedAt',
      name: 'Updated At',
      render: (row) => <span>{moment(row?.updatedAt).format('DD MMM YYYY')}</span>,
    },

    {
      key: 'action',
      name: 'Action',
      render: (itm) => (
        <div className="flex items-center justify-start gap-1.5">

          {/* View */}
          {methodModel.hasPermission(user, shared.permissionKey, 'read') ? (
            <Tooltip placement="top" title="View">
              <a
                onClick={() => view(itm?.id || itm?._id)}
                className="cursor-pointer rounded-full w-8 h-8 flex items-center justify-center text-sm hover:opacity-80 bg-[#F2F2F2] text-[#797979]"
              >
                <FaEye />
              </a>
            </Tooltip>
          ) : null}


          {/* Edit */}
          {methodModel.hasPermission(user, shared.permissionKey, 'edit') ? (
            <Tooltip placement="top" title="Edit">
              <a
                onClick={() => edit(itm?.id || itm?._id)}
                className="cursor-pointer rounded-full w-8 h-8 flex items-center justify-center text-sm hover:opacity-80 bg-[#F2F2F2] text-[#797979]"
              >
                <FaEdit />
              </a>
            </Tooltip>
          ) : null}

        </div>
      ),
    },
  ];

  const tabItems = [
    { key: '', label: 'All' },
    { key: 'app', label: 'App' },
    { key: 'web', label: 'Web' },
  ];

  return (
    <Layout>
      <div className="flex flex-wrap justify-between items-center gap-y-4 mb-5">
        <div>
          <h3 className="text-2xl font-semibold text-[#111827]">{shared.title}</h3>
        </div>
      </div>

      <div className="">
        <div className="flex items-center flex-wrap gap-2 mb-4">
          <form
            className="flex items-center max-w-sm gap-2"
            onSubmit={(e) => {
              e.preventDefault();
              filter();
            }}
          >
            <label htmlFor="simple-search" className="sr-only">
              Search
            </label>
            <div className="relative w-full">
              <input
                type="text"
                id="simple-search"
                value={filters.search}
                onChange={(e) => {
                  setFilter({ ...filters, search: e.target.value });
                  if (e.target.value === '') filter({ search: '' });
                }}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-orange-500 focus:border-[#063688] block w-full h-10 px-5 pr-11"
                placeholder="Search....."
              />
              {filters?.search && (
                <i
                  className="fa fa-times absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 text-sm cursor-pointer"
                  aria-hidden="true"
                  onClick={(e) => clear()}
                />
              )}
              <button type="submit" className="text-[#2D2D2D] absolute top-[13px] right-[15px] hover:opacity-80">
                <svg
                  className="w-4 h-4"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                  />
                </svg>
                <span className="sr-only">Search</span>
              </button>
            </div>
          </form>

          <div className="ml-auto flex items-center gap-2">
            {tabItems.map((item) => (
              <button
                key={item.key}
                onClick={() => filter({ platform: item.key })}
                className={`px-5 py-1.5 rounded-full text-sm font-medium transition-all duration-200 border ${filters.platform === item.key
                  ? 'bg-primary border-primary text-white shadow-sm'
                  : 'bg-gray-100 border-transparent text-gray-600 hover:bg-gray-200'
                  }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>

        {!loading ? (
          <Table
            className="mb-3"
            data={data}
            columns={columns}
            page={filters.page}
            count={filters.count}
            filters={filters}
            total={total}
            result={(e) => {
              if (e.event === 'page') pageChange(e.value);
              if (e.event === 'count') count(e.value);
            }}
          />
        ) : (
          <></>
        )}
      </div>

      {/* How It Works Guide Modal */}
      <CustomModal
        open={isHelpModalVisible}
        onClose={() => setIsHelpModalVisible(false)}
        width={650}
      >
        <div className="flex flex-col font-sans">
          {/* Header */}
          <div className="bg-gradient-to-r from-[#CC9900] via-[#E6B800] to-[#CC9900] p-6 text-white relative">
            <div className="flex justify-between items-start gap-4">
              <div>
                <h3 className="text-xl font-bold leading-snug">
                  💡 How Content Management Works
                </h3>
                <p className="text-sm text-white/90 mt-1">
                  Platform targeting guidelines for app and web pages
                </p>
              </div>
            </div>
          </div>

          {/* Ticket Dotted Separator */}
          <div className="relative bg-gray-50" style={{ height: '28px' }}>
            <svg className="absolute left-0 top-0 h-full" style={{ width: '14px' }} viewBox="0 0 14 28" preserveAspectRatio="none">
              <path d="M0,0 C14,0 14,28 0,28 Z" fill="white" />
            </svg>
            <div className="absolute" style={{ top: '50%', left: '14px', right: '14px', transform: 'translateY(-50%)', borderTop: '1.5px dashed #d1d5db' }} />
            <svg className="absolute right-0 top-0 h-full" style={{ width: '14px' }} viewBox="0 0 14 28" preserveAspectRatio="none">
              <path d="M14,0 C0,0 0,28 14,28 Z" fill="white" />
            </svg>
          </div>

          {/* Modal Body */}
          <div className="p-6 space-y-6">
            <p className="text-sm text-gray-600 leading-relaxed">
              TavLoy manages policies, terms, and conditions separately for customers and venues. Note the targeting details below to avoid confusion:
            </p>

            <div className="space-y-4">
              {/* App Platform */}
              <div className="flex gap-4 p-4 rounded-xl border border-[#CC9900]/20 bg-[#CC9900]/5">
                <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-[#CC9900]/10 text-[#CC9900] flex-shrink-0">
                  <FaMobileAlt size={16} />
                </span>
                <div>
                  <h4 className="font-bold text-[#8B6E1E] text-sm mb-1">App Platform (pointing to Customers)</h4>
                  <p className="text-xs text-gray-600 leading-relaxed">
                    Pages marked under the **App** platform are shown directly to customers/users inside the mobile app. Update these when updating consumer-facing policies or T&C.
                  </p>
                </div>
              </div>

              {/* Web Platform */}
              <div className="flex gap-4 p-4 rounded-xl border border-gray-200 bg-gray-50">
                <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-gray-200/50 text-gray-500 flex-shrink-0">
                  <FaGlobe size={16} />
                </span>
                <div>
                  <h4 className="font-bold text-gray-700 text-sm mb-1">Web Platform (pointing to Venues)</h4>
                  <p className="text-xs text-gray-600 leading-relaxed">
                    Pages marked under the **Web** platform are shown on the website and partner dashboard interfaces. Update these for partner-facing venue agreements and legal terms.
                  </p>
                </div>
              </div>

              {/* Duplicate Titles note */}
              <div className="flex gap-4 p-4 rounded-xl border border-amber-100 bg-amber-50/50">
                <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-amber-100 text-amber-600 font-bold text-sm flex-shrink-0">💡</span>
                <div>
                  <h4 className="font-bold text-[#8B6E1E] text-sm mb-1">Matching Headings</h4>
                  <p className="text-xs text-gray-600 leading-relaxed">
                    Both App and Web platforms may share the exact same headings (e.g. *Terms & Conditions* or *Privacy Policy*). Always check the **Platform** column to distinguish them.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="bg-gray-50 px-6 py-4 border-t border-gray-100 flex justify-end">
            <button
              onClick={() => setIsHelpModalVisible(false)}
              className="px-5 py-2 rounded-xl border border-gray-200 text-gray-600 hover:bg-gray-100 transition-all text-xs font-semibold"
            >
              Got it, thanks!
            </button>
          </div>
        </div>
      </CustomModal>

      {/* Floating Help Button */}
      <Tooltip placement="left" title="How It Works">
        <button
          type="button"
          onClick={() => setIsHelpModalVisible(true)}
          className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-12 h-12 rounded-full bg-[#CC9900] text-white shadow-lg hover:bg-[#B38000] hover:scale-110 active:scale-95 transition-all duration-300"
        >
          <FiHelpCircle className="text-2xl" />
        </button>
      </Tooltip>
    </Layout>
  );
}

export default Html;
